import React, { useState, useEffect } from 'react';
import NavBar from '../../components/nav/NavBar';
import Footer from '../../components/footer/Footer';
import '../../scss/style/tripSuggestion.scss';
import Historical_img from '../../assets/images/imgg1.webp';
import Art_img from '../../assets/images/imgg2.webp';
import beach_img from '../../assets/images/imgg3.webp';
import mosque from '../../assets/images/imgg44.webp';
import mapImage from '../../assets/images/map.png'; 
import "./trip.scss"

const TripSuggestion = () => {
  const [places, setPlaces] = useState(['Place 1', 'Place 2', 'Place 3', 'Place 4']);
  const [loading, setLoading] = useState(false);
  const [selectedCards, setSelectedCards] = useState([]);

  useEffect(() => {
  }, []);

  const fetchPlaces = async () => {
    if (selectedCards.length === 0) return; 
  
    setLoading(true);
    const categories = selectedCards.join(' ');
  
    const apiUrl = 'https://generativelanguage.googleapis.com/v1beta/models/gemini-1.5-flash:generateContent?key=AIzaSyBSbUr0TmCMSGcFOdsO24PUOEsLmQu-8ec';
    try {
      const requestBody = JSON.stringify({
        "contents": [
          {
            "parts": [
              { "text": `Suggest 4 places to visit in Egypt for ${categories}, separate names with a '+' symbol. and give the names only` }
            ]
          }
        ]
      });
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: requestBody
      });
      const data = await response.json();
  
      if (response.ok) {
        const placesText = data.candidates[0].content.parts[0].text.trim();
        const newPlaces = placesText.split('+').map(place => place.trim()).slice(0, 4);
        setPlaces(newPlaces);
      } else {
        throw new Error('Failed to fetch places');
      }
    } catch (error) {
      console.error('Error fetching places:', error);
      setPlaces(['Error loading', 'Error loading', 'Error loading', 'Error loading']);
    } finally {
      setLoading(false);
    }
  };
  

  const handleCardClick = (cardName) => {
    const index = selectedCards.indexOf(cardName);
    if (index > -1) {
      setSelectedCards(selectedCards.filter(c => c !== cardName));
    } else {
      setSelectedCards([...selectedCards, cardName]); 
    }
  };

  return (
    <>
      <NavBar />
      <div className='cardes-categories-holder'>
        {[
          { name: 'Historical', img: Historical_img },
          { name: 'Artistic', img: Art_img },
          { name: 'Beach', img: beach_img },
          { name: 'Religious', img: mosque }
        ].map(card => (
          <div
            key={card.name}
            className={`card-container ${selectedCards.includes(card.name) ? 'selected' : ''}`}
            onClick={() => handleCardClick(card.name)}
          >
            <img className="images" src={card.img} alt={card.name} />
            <div className="texts-container">
              <div className="name">{card.name} places</div>
            </div>
          </div>
        ))}
      </div>
      <div className='trip-suggestion-holder'>
        <img className='map-image' src={mapImage} alt='Map' />

        <div className='pin-container' style={{ top: '12.7%', left: '33%' }}>
          <span className='pin-num'>1</span>
          <span className='pin-label'>{places[0]}</span>
        </div>
        <div className='pin-container' style={{ top: '0.1%', left: '50%' }}>
          <span className='pin-num'>2</span>
          <span className='pin-label'>{places[1]}</span>
        </div>
        <div className='pin-container' style={{ top: '32.5%', left: '42.5%' }}>
          <span className='pin-num'>3</span>
          <span className='pin-label'>{places[2]}</span>
        </div>
        <div className='pin-container' style={{ top: '13.5%', left: '62%' }}>
          <span className='pin-num'>4</span>
          <span className='pin-label'>{places[3]}</span>
        </div>

        <button className='another-trip' onClick={fetchPlaces} disabled={loading}>
          {loading ? 'Loading...' : 'Suggest trip'}
        </button>
      </div>
      <Footer />
    </>
  );
}

export default TripSuggestion;
